import { Controller } from "@hotwired/stimulus"

// Drives the what-to-track fields shared by the live-start and manual
// time-tracking forms (admin/time_tracking/sessions/_task_fields.html.erb):
// the Client time / Internal time radio swaps the panes (the submitted
// `kind` decides server-side which pane's fields count), and selecting an
// account points two turbo frames at their options endpoints --
// `manual-task-frame` at TaskOptionsController#index and
// `manual-service-frame` at ServiceOptionsController#index -- each
// returning a select named for the field it fills, scoped to that account.
//
// Task derives from service, one way, mirroring the timesheet form
// (timesheet_form_controller#serviceChanged): choosing a service refetches
// the task list scoped to it, which drops any task already chosen, while
// choosing a task leaves the service alone.
export default class extends Controller {
  static targets = ["clientFields", "internalFields", "account", "service"]

  kindChanged(event) {
    const internal = event.target.value === "internal"
    if (this.hasClientFieldsTarget) this.clientFieldsTarget.classList.toggle("d-none", internal)
    if (this.hasInternalFieldsTarget) this.internalFieldsTarget.classList.toggle("d-none", !internal)
  }

  loadTasks(event) {
    const accountId = event.target.value
    this.pointFrame("manual-task-frame", "/admin/time_tracking/task_options", { account_id: accountId })
    this.pointFrame("manual-service-frame", "/admin/time_tracking/service_options", { account_id: accountId })
  }

  // Refetching the task frame is what clears the task: the server renders
  // the select with nothing selected.
  serviceChanged(event) {
    if (!this.hasAccountTarget) return

    this.pointFrame("manual-task-frame", "/admin/time_tracking/task_options", {
      account_id: this.accountTarget.value,
      service_id: event.target.value
    })
  }

  pointFrame(frameId, path, params) {
    const frame = document.getElementById(frameId)
    if (!frame) return

    if (!params.account_id) {
      frame.innerHTML = ""
      return
    }

    const query = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
      if (value) query.set(key, value)
    })
    frame.src = `${path}?${query.toString()}`
  }
}
